import ResizeController from '../../../assets/js/controllers/resize';

import Platform from '../../../assets/js/constants/platform';

import { multiClassList } from '../../../assets/js/helpers';

export default class HeroSecondary {

	static selector = 'hero-secondary';

	// class variables

	el = {};

	controllers = {
		resize: null
	};

	states = {
		platform: null,
		activeLogo: null,
		loopIndex: -1
	};

	timeouts = {
		logoRotate: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			logos: container.querySelectorAll(`.${this.constructor.selector}__top-bar-logo`)
		};

		this.initialize();
	}

	initialize() {
		this.#addEventListeners();
	}

	// event listeners

	#addEventListeners = () => {
		this.controllers.resize = ResizeController.set({
			update: this.#onResizeUpdate,
			render: this.#onResizeRender
		});

		this.#measureResize();
		this.#adjustResize();
	}

	#removeEventListeners = () => {
		ResizeController.clear(this.controllers.resize);
	}

	// listener methods

	#onResizeUpdate = () => this.#measureResize();

	#onResizeRender = () => {
		this.#adjustResize();
	}

	#measureResize = () => {
		if (this.states.platform !== ResizeController.platform) {
			this.states.platform = ResizeController.platform;
			return true;
		}

		return false;
	}

	#adjustResize = () => {
		if (this.states.platform !== Platform.DESKTOP) {
			this.fadeLoopStart();
		} else {
			this.fadeLoopKill();
		}
	}

	//

	fadeLoopStart() {
		if (!this.timeouts.logoRotate) {
			this.states.loopIndex = -1;
			this.fadeLoopNext();
		}
	}

	fadeLoopNext() {
		this.fadeLoopKill();

		this.states.loopIndex++;
		if (this.states.loopIndex >= this.el.logos.length) {
			this.states.loopIndex = 0;
		}

		multiClassList(this.el.logos, 'remove', 'is-active');

		this.states.activeLogo = this.el.logos[this.states.loopIndex];
		this.states.activeLogo.classList.add('is-active');

		this.timeouts.logoRotate = setTimeout(this.fadeLoopNext.bind(this), 3000);
	}

	fadeLoopKill() {
		if (this.timeouts.logoRotate) {
			clearTimeout(this.timeouts.logoRotate);
			this.timeouts.logoRotate = null;
		}
	}

	//

	destroy() {
		this.#removeEventListeners();
	}

}
